module.exports = __webpack_public_path__ + "static/media/Pasargad.7053d910.svg";